import axios from "@/api/config";

const agentInfo = {
  addAgentInfo(data) {
    return axios.post(`${process.env.BASE_URL}/agentInfo/addAgentInfo`, data);
  },
  updateAgentInfo(data) {
    return axios.put(`${process.env.BASE_URL}/agentInfo/updateAgentInfo`, data);
  },
  getIndexAgentInfo() {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfo`);
  },
  getTopTenNotice(data) {
    return axios.post(`${process.env.BASE_URL}/notice/pageList`, data);
  },
  getListByOrder(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getListByOrderCount`, {
      params: data
    });
  },
  quizRankList(data) {
    return axios.post(`${process.env.BASE_URL}/questionAnswering/questionAnsweringTopList`, data);
  },
  getListByDateChart(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getListByDate`, {
      params: data
    });
  },
  getCammpusConsume(data) {
    return axios.get(
      `${process.env.BASE_URL}/agentAmountLog/getAgentAmountByTime`,
      {
        params: data
      }
    );
  },
  getCammpusInfo(data) {
    return axios.get(`${process.env.BASE_URL}/campus/getCampusInfo`, {
      params: data
    });
  },
  getAlreadySellCounts(data) {
    return axios.get(`${process.env.BASE_URL}/orderInfo/getOrderInfoCount`, {
      params: data
    });
  },
  addAgentAmountLogV2(data) {
    return axios.post(
      `${process.env.BASE_URL}/agentAmountLog/addAgentAmountLogV2`,
      data
    );
  }
};

export default agentInfo;



// WEBPACK FOOTER //
// ./src/api/agentInfo.js